import React, { createContext, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { notikey } from '../config';
import { suscribePushNotifications } from '../_apis_/notifications';
// firestore
import { firestore } from './FirebaseContext';
import moment from 'moment';

export const NotificationsContext = createContext({ notifications: [] });

export default function NotificationsProvider({ children }) {
  const { isAuthenticated, user } = useAuth();

  const [notifications, setNotifications] = useState([]);

  const pushNotification = async (notification) => {
    if (notification?.pushed) {
      // Notification.requestPermission().then(async (perm) => {

      new Notification(notification.title, { body: notification.description });
      await firestore.collection('notifications').doc(notification.id).update({ pushed: true });

      // });
    }
  };

  useEffect(() => {
    async function suscribePush() {
      const docs = await firestore.collection('subscriptions-notif').where('userid', '==', user.id).get();
      if (docs.docs.length === 0) {
        const registration = await navigator.serviceWorker.getRegistration();
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: notikey
        });
        console.log(JSON.parse(JSON.stringify(subscription)));
        suscribePushNotifications(subscription, user.id)
          .then((resp) => {
            console.log('suscrito');
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
    if ('serviceWorker' in navigator && isAuthenticated) {
      suscribePush();
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    async function getNotifications() {
      await firestore
        .collection('notifications')
        .where('userid', '==', user.id)
        .where('createdAt', '>', moment().subtract(2, 'day').toDate())
        .orderBy('createdAt', 'desc')
        .onSnapshot((queryS) => {
          const nots = [];
          queryS.forEach((doc) => {
            const data = { id: doc.id, ...doc.data() };
            pushNotification(data);
            nots.push(data);
          });
          setNotifications(nots);
        });
    }
    getNotifications();
  }, [user]);

  return <NotificationsContext.Provider value={{ notifications }}>{children}</NotificationsContext.Provider>;
}
